import { i18n } from '../../i18n';
import { TAG_TYPE } from '@/constants';
import _ from 'lodash';

export const BANNER_PAGE_POSITIONS = [
  'event',
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link',
]


export const filterColumnsHash = {
  page_position_eq: {
    label: i18n.t('banner.pagePosition'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(BANNER_PAGE_POSITIONS, (value) => ({ label: i18n.t(`banner.pagePositions.${value}`), value: value }))
      }
    }
  },
  kind_eq: {
    label: i18n.t('banner.kind'),
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(BANNER_KINDS, (value) => ({ label: i18n.t(`banner.kinds.${value}`), value: value }))
      }
    }
  },
}

export const columnsHash = {
  id: {
    label: i18n.t('banner.id'),
    width: 80,
  },
  alt: {
    label: i18n.t('banner.alt'),
  },
  page_position: {
    label: i18n.t('banner.pagePosition'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.page_position) {
        return <span>/</span>
      }
      return <el-tag type={TAG_TYPE[row.page_position]}>{i18n.t(`banner.page_positions.${row.page_position}`)}</el-tag>;
    },
  },
  kind: {
    label: i18n.t('banner.kind'),
    renderCell: (h, { props: { scope: { row } } }) => {
      if (!row.kind) {
        return <span>/</span>
      }
      return <el-tag type={TAG_TYPE[row.kind]}>{i18n.t(`banner.kinds.${row.kind}`)}</el-tag>;
    },
  },
  position: {
    label: i18n.t('banner.position'),
  },
  created_at: {
    label: i18n.t('banner.createdAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  updated_at: {
    label: i18n.t('banner.updatedAt'),
    minWidth: 120,
    renderCell: 'time',
  },
  image: {
    label: i18n.t('banner.image'),
    width: 120,
    renderCell: 'storageAttachment',
  },
}

export const formColumnsHash = {
  page_position: {
    label: i18n.t('banner.pagePosition'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        options: _.map(BANNER_PAGE_POSITIONS, (value) => ({ label: i18n.t(`banner.pagePositions.${value}`), value: value }))
      }
    }
  },
  kind: {
    label: i18n.t('banner.kind'),
    renderCell: {
      required: true,
      component: 'select',
      props: {
        options: _.map(BANNER_KINDS, (value) => ({ label: i18n.t(`banner.kinds.${value}`), value: value }))
      }
    }
  },
  position: {
    label: i18n.t('banner.position'),
    renderCell: {
      component: 'input',
      props: {
        type: 'number'
      },
    },
  },
  image: {
    label: i18n.t('banner.image'),
    width: 120,
    renderCell: {
      required: true,
      component: 'upload',
    }
  },
}
